import Image from "~/components/atoms/Image";
import iconClose from "~/assets/icon-close.svg";
import chevronRight from "~/assets/chevron-right.svg";
import { CollapsibleMenu, SubSectionContainer } from "~/components/organisms/navigation-bar/shared";
import {
    BoardingSchool,
    CollegeRecruiting,
    DevelopmentalCoaching,
    MembershipTypes,
    OtherExperiences,
    PopularLinks,
    PremierePartners,
    SportCamps,
} from "~/components/organisms/navigation-bar/sections";
import plusLogo from "~/assets/imga-plus-text-logo.svg";
import { Form } from "react-router";
import { cn } from "~/lib/utils";
import AthleteAvatar from "~/components/molecules/AthleteAvatar";

function OnCampus() {
    return (
        <div className="flex flex-col gap-3 p-[20px]">
            <div className="text-[17px] font-bold text-blue-80">Youth</div>
            <div className="flex flex-col gap-8">
                <BoardingSchool />
                <SportCamps />
                <OtherExperiences />
                <div className="max-w-[228px]">
                    <SubSectionContainer title="Premier Partners">
                        <div className="py-4">
                            <PremierePartners />
                        </div>
                    </SubSectionContainer>
                </div>
            </div>
        </div>
    );
}

function Online() {
    return (
        <div className="flex flex-col gap-8 p-[20px]">
            <Image loading="lazy" alt="IMGA+ Logo" src={plusLogo} className="w-[200px]" />
            <DevelopmentalCoaching />
            <MembershipTypes />
            <CollegeRecruiting />
            <SubSectionContainer title="Premier Partners">
                <div className="max-w-[228px] py-4">
                    <PremierePartners />
                </div>
            </SubSectionContainer>
        </div>
    );
}

interface NavigationMobileProps {
    isAuthenticated?: boolean;
    onClose: () => void;
}
export function NavigationMobile({ onClose, isAuthenticated }: NavigationMobileProps) {
    return (
        <div className="size-full">
            <div className="fixed z-20 flex h-[60px] w-full items-center border-b-[0.5px] border-b-gray-20 bg-white px-3">
                <Image
                    src={iconClose}
                    width={18}
                    alt="close"
                    className="absolute left-4 cursor-pointer py-2"
                    data-testid="mobile-navigation-close"
                    onClick={onClose}
                />
                <div
                    role="img"
                    aria-description="IMGA Plus Home Logo"
                    className={cn(
                        "m-auto",
                        isAuthenticated
                            ? "logo-plus-icon sm:logo-plus-text"
                            : "logo-icon sm:logo-text",
                    )}
                />
            </div>
            <hr />
            {!isAuthenticated ? (
                <nav className="mt-[60px] flex size-full flex-col gap-5 p-[30px]">
                    <CollapsibleMenu title="On Campus">
                        <OnCampus />
                    </CollapsibleMenu>
                    <CollapsibleMenu title="Online">
                        <Online />
                    </CollapsibleMenu>
                    <a href="https://www.imgacademy.com/contact-us">
                        <span className="text-[22px] font-bold text-blue-80">Contact Us</span>
                    </a>
                    <hr className="my-2" />
                    <PopularLinks />
                </nav>
            ) : (
                <section className="mt-[60px] flex h-[calc(100dvh-60px)] flex-col gap-6 p-[30px]">
                    <header className="flex items-center gap-4">
                        <AthleteAvatar size="header" />
                        <h2 className="text-xl font-bold tracking-wide text-gray-80">
                            Hi, Athlete first name
                        </h2>
                    </header>
                    <nav className="flex min-h-[25px] items-center justify-between text-base font-normal text-gray-80">
                        <span>Account Settings</span>
                        <Image src={chevronRight} alt="Right Chevron Icon" className="size-5" />
                    </nav>
                    <hr className="my-2" />
                    <div className="mt-auto text-center">
                        <Form action="/auth/logout" method="post" className="mx-3">
                            <button className="text-xl underline">Log out</button>
                        </Form>
                    </div>
                </section>
            )}
        </div>
    );
}
